import { atomFamily } from "recoil";

import { type PaginationAtomsKeys } from "../../../shared/state";
import { type Pagination, type PaginationFilter, defaultPagination, defaultPaginationFilter } from "../models";

export const paginationAtom = atomFamily<Pagination, PaginationAtomsKeys>({
    key: "PaginationAtom",
    default: defaultPagination,
});

export const paginationFilterAtom = atomFamily<PaginationFilter, PaginationAtomsKeys>({
    key: "PaginationFilterAtom",
    default: defaultPaginationFilter,
});
